// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__3lRqP","dataspaceRight":"style_dataspaceRight__2aaRT","previewing":"style_previewing__6X_P3","previewTip":"style_previewTip__YUQ3L"};